import { render } from "./GoTopButton.vue?vue&type=template&id=1ff8cb2c&scoped=true"
import script from "./GoTopButton.vue?vue&type=script&lang=js"
export * from "./GoTopButton.vue?vue&type=script&lang=js"

import "./GoTopButton.vue?vue&type=style&index=0&id=1ff8cb2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3fde62ecf17df48f63b2288f8ccd725b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff8cb2c"]])

export default __exports__